/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { InfoItem } from '@molecules';
import { pluralize } from '@utils';

const DualTextBlockItem = ({ module: { content }, errors }) => {
  return (
    <InfoItem.WithError error={errors} size="large" description={pluralize(content.questions?.length, 'question')}>
      FAQ
    </InfoItem.WithError>
  );
};

export default DualTextBlockItem;
